var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF602") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF602",
    transform: "translate(-0, 0)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7906263,8.56406307 L12.8531263,17.7515631 C12.6890638,18.1312494 12.3187501,18.375 11.8640635,18.375 C11.840626,18.375 11.7703135,18.3703122 11.700001,18.3562503 C11.2218754,18.2578125 10.8750007,17.8312497 10.8750007,17.34375 L10.8750007,13.125 L6.6140635,13.125 C6.168751,13.125 5.74218822,12.7781253 5.64375043,12.2999997 C5.54531264,11.8265626 5.80312514,11.3390622 6.24843764,11.1468751 L15.4359369,7.20937443 C15.8343744,7.04531193 16.2796869,7.12968779 16.5750003,7.4296875 C16.8328128,7.72499943 16.9593744,8.17031193 16.7906256,8.56406307 L16.7906263,8.56406307 Z M24,12 C24,18.6281247 18.6281247,24 12,24 C5.37187529,24 0,18.6281247 0,12 C0,5.37187529 5.37187529,0 12,0 C18.6281247,0 24,5.37187529 24,12 Z M12,2.25 C6.61406279,2.25 2.25,6.61406279 2.25,12 C2.25,17.3859372 6.61406279,21.75 12,21.75 C17.3859372,21.75 21.75,17.3859372 21.75,12 C21.75,6.61406279 17.3859372,2.25 12,2.25 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationArrow);
export default __webpack_public_path__ + "static/media/location-arrow.3b52384c80e7555322e8d6c9f543050c.svg";
export { ForwardRef as ReactComponent };